module.exports = __webpack_public_path__ + "img/DigitalCommerce.2c3352af.svg";